/** @jsxImportSource @emotion/react */
import { ReactChild } from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  SpaceScale,
  ResponsiveValue,
} from '@gousto-internal/citrus-react'
import bgImage from '../../assets/backgrounds/heroMessage.svg'

type HeroProps = {
  children: ReactChild | ReactChild[],
  paddingH?: ResponsiveValue<SpaceScale>,
}

const Hero = ({ children, paddingH }: HeroProps) => (
  <Box
    height={['80px', '144px', '160px']}
    width="100%"
    display={Display.Flex}
    alignItems={AlignItems.Center}
    paddingH={paddingH || 6}
    color={Color.White}
    bg={Color.ColdGrey_800}
    css={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <Box width="100%">
      {children}
    </Box>
  </Box>
)

export { Hero }
